import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	direction: "column",
	gap: "12",
});

export const emailRowClass = flex({
	alignItems: "flex-end",
	gap: "12",
	flexWrap: "wrap",
});

export const emailFieldClass = css({
	minWidth: "[320px]",
});

export const actionsRowClass = flex({
	alignItems: "center",
	gap: "8",
	flexWrap: "wrap",
});

export const hintClass = css({
	fontSize: "12",
	color: "shade.60",
});

export const notEditableHintClass = css({
	fontSize: "12",
	color: "warning.100",
});

export const dialogFooterClass = flex({
	justifyContent: "flex-end",
	gap: "8",
});

export const confirmEmailClass = css({
	marginTop: "8",
	fontWeight: "bold",
	wordBreak: "break-all",
});
